// Date and string formatters

export function formatYear(year: number, circa = false): string {
  const abs = Math.abs(year)
  const suffix = year < 0 ? ' BCE' : ' CE'
  return `${circa ? 'c. ' : ''}${abs}${suffix}`
}

export function formatYearRange(start: number, end?: number, circa = false): string {
  if (end === undefined || end === start) return formatYear(start, circa)
  // Both BCE: condense
  if (start < 0 && end < 0) {
    return `${circa ? 'c. ' : ''}${Math.abs(start)}–${Math.abs(end)} BCE`
  }
  if (start > 0 && end > 0) {
    return `${circa ? 'c. ' : ''}${start}–${end} CE`
  }
  // Spans 0
  return `${formatYear(start, circa)} – ${formatYear(end)}`
}

export function normalizeQuery(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // strip diacritics for matching
    .replace(/[^\w\s]/g, '')
    .trim()
}
